import IdpList from './model';
import create from './create';

IdpList.create = create;

export default IdpList;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/IdpList/index.js